/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ViewMode/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import ShowFutureReceivables from './ShowFutureReceivables/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ViewMode({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/ViewMode"
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let tabSelectedLedgerViewModeValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.ledger.view_mode',
})
let constantData = 'receivables'
let aggregateData = fromAggregate.equals(tabSelectedLedgerViewModeValueData, constantData)
let onClick = fromHelpers.useOnClickReceivables({
  children,
  viewPath
  
})
let tabSelectedLedgerViewModeValueData1 = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.ledger.view_mode',
})
let constantData1 = 'transactions'
let aggregateData1 = fromAggregate.equals(tabSelectedLedgerViewModeValueData1, constantData1)
let onClick1 = fromHelpers.useOnClickTransactions({
  children,
  viewPath
  
})
let tabSelectedLedgerViewModeValueData2 = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.ledger.view_mode',
})
let constantData2 = 'notes'
let aggregateData2 = fromAggregate.equals(tabSelectedLedgerViewModeValueData2, constantData2)
let onClick2 = fromHelpers.useOnClickNotes({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Show &#8250;"
 weight="medium"
 color={dtColorsNeutral400}
 size="small"
/>
<div
  data-testid="ViewMode.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 borderTopRightRadius={0}
 borderBottomRightRadius={0}
 onClick={onClick}
 type={aggregateData ? "primary" : "secondary"}
 data="tab.selected.ledger.view_mode"
 data="'receivables'"
 aggregate="/Data/aggregate.js equals"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Invoices & Claims"
/>
)}
</TysiaButton>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 borderTopLeftRadius={0}
 borderBottomLeftRadius={0}
 borderTopRightRadius={0}
 borderBottomRightRadius={0}
 onClick={onClick1}
 type={aggregateData1 ? "primary" : "secondary"}
 data="tab.selected.ledger.view_mode"
 data="'transactions'"
 aggregate="/Data/aggregate.js equals"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Transactions"
/>
)}
</TysiaButton>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 borderTopLeftRadius={0}
 borderBottomLeftRadius={0}
 onClick={onClick2}
 type={aggregateData2 ? "primary" : "secondary"}
 data="tab.selected.ledger.view_mode"
 data="'notes'"
 aggregate="/Data/aggregate.js equals"
>
{childProps => (
<React.Fragment>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Notes"
/>
<TysiaTag
{...childProps}
  viewPath={`${viewPath}/TysiaTag`}
 type="grey"
 style="filled"
 size="small"
 alignSelf="center"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text={2}
/>
)}
</TysiaTag>
</React.Fragment>
)}
</TysiaButton>
</div>
<ShowFutureReceivables
  viewPath={`${viewPath}/ShowFutureReceivables`}
/>
{children}
</React.Fragment>)
}